import { ref, reactive, computed } from 'vue'
import { defineStore } from 'pinia'

// import Ajax from '@utils/ajax'
import { useAppointment } from '@store/appointment'
import { useSettings } from '@store/settings'
import { useCustomer } from '@store/customer'
const $customer = useCustomer()

import Transaction from '@model/transaction'

export const useTransaction = defineStore('transaction', () => {
    const $appointment = useAppointment()
    const $settings = useSettings()

    // const isLoading = ref(false)

    // Fetch all transactions
    const transactions = ref([])
    const getTransactions = computed(() => transactions.value)
    const fetchTransactions = async () => {
        transactions.value = await Transaction.init().all()
        return transactions.value.forEach(transaction => {
            transaction.meta['checkbox'] = false
            transaction.customer_image = $customer.findCustomerById(transaction.customer_id).meta?.profile_image_url || ''
            transaction.service_name = $appointment.getAppointments.find(ap => ap.appointment_id == transaction.appointment_id)?.meta?.service_name || ''
        })
    }

    // Fetch single transaction
    const transaction = ref({})
    const getTransaction = computed(() => transaction.value)
    const model = (transaction_id = null) => {
        return new Transaction({ transaction_id: transaction_id })
    }
    const fetchTransaction = async (transaction_id = null) => {
        await $appointment.fetchData()

        transaction.value = await model(transaction_id).get()
        // console.log($appointment.getAppointments)
        transaction.value.service_name = $appointment.getAppointments.find(ap => ap.appointment_id == transaction.value.appointment_id)?.meta?.service_name || '-'
    }

    const createTransaction = async (data) => {
        return await Transaction.init().create(data)
    }


    // filter transaction
    const filterTransaction = async (search) => {
        console.log('transaction search', search)
    }

    const bulkDelete = async (ids) => {
        if (!ids || !ids.length) return Toast.warning('Nothing to delete!')
        let response = await Transaction.init().bulkDelete(ids)

        if (response.success) {
            Toast.success(`${ids.length > 1 ? ids.length : ''} ${String($settings.labels.payment?.singular)}${ids.length > 1 ? 's' : ''} deleted successfully`)
            await fetchTransactions()
        }
        else {
            Toast.success(response.message)
        }
    }

    // export
    return {
        // isLoading,
        getTransactions,
        fetchTransactions,
        getTransaction,
        fetchTransaction,

        filterTransaction,
        createTransaction,
        bulkDelete,
        model
    }
})
